export const getDropDownHeight = (optionHeight: number) => `${6.5 * optionHeight + 8}px`; // 6.5 options * option height + 8px padding

export type ChipColor = 'error' | 'default' | 'primary' | 'success' | 'warning';
